import { render, staticRenderFns } from "./SequencesWiki.vue?vue&type=template&id=0268a376&scoped=true"
import script from "./SequencesWiki.vue?vue&type=script&lang=js"
export * from "./SequencesWiki.vue?vue&type=script&lang=js"
import style0 from "./SequencesWiki.vue?vue&type=style&index=0&id=0268a376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0268a376",
  null
  
)

export default component.exports